export const ENGAGEMENT_SOURCE = {
	FAVORITE: 'favorite',
	FEATURED: 'featured',
	TRENDING: 'trending',
	SPECIAL: 'special'
} as const;
export type TEngagementSource = typeof ENGAGEMENT_SOURCE[keyof typeof ENGAGEMENT_SOURCE];
